import React, { useEffect } from 'react';

function LoginCallbackPage() {
  useEffect(() => {
    window.close();
  }, []);

  return (
    <div>
      Closing....
    </div>
  );
}

export default LoginCallbackPage;
